import { MedicalOrderRequestDto } from 'src/app/shared/models/medical-order/medical-order-request-dto.model';
import { IMedicalOrderChain } from './medical-order-chain';
import { MedicalOrderNodeValue } from 'src/app/shared/models/medical-order/medical-order-node-value';

export class MedicalOrderChainHandler implements IMedicalOrderChain {
  next = {
    handleRequest(medicalOrderDto: MedicalOrderRequestDto, request: MedicalOrderNodeValue) {
      console.log('All strategies exhausted.');
    },
  };

  setNext(next) {
    this.next = next;
    return next;
  }

  handleRequest(medicalOrderDto: MedicalOrderRequestDto, request: MedicalOrderNodeValue) {}
}
